module.exports = __webpack_public_path__ + "static/media/new.898bbe86.png";